export default "__VITE_ASSET__nMga7jihVSyK103YfUNlOQ__"